module.exports = __webpack_public_path__ + "static/lawadvisor-services-04-45bb49384461479be99d99904bcc8d98.jpg";